import React from 'react';
import { connect } from 'react-redux';
import template from '../../../../templates/Stones/AssignPricing/AssignPricingProfile/index.rt';
import * as actions from '../../../../actions';
import _ from 'lodash';

let toTitleCase = (str) => {
  return str.replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();});
}

function mapStateToProps(state) {
  const { fabricatorStones, stones } = state.stonesV2;
  let stonesAssignedToSelectedProfile = [];
  if(state.pricingPreset.selectedPreset.id > 0) {
    stonesAssignedToSelectedProfile = fabricatorStones.filter(s => {
      return (s.fabricatorStoneData && s.fabricatorStoneData.pricingPresetId === state.pricingPreset.selectedPreset.id);
    });
    stonesAssignedToSelectedProfile.sort((a,b) => {
      let aName = _.trim(a.name).toLowerCase()
        , bName = _.trim(b.name).toLowerCase();
      if(aName < bName)
        return -1;
      else if(aName > bName)
        return 1;
      else
        return 0;
    });
  }
  return {
    presets: state.pricingPreset.presets,
    selectedPreset: state.pricingPreset.selectedPreset,
    selectedStones: state.pricingPreset.selected,
    assignPricingProfileStones: state.pricingPreset.assignPricingProfileStones,
    stonesAssignedToSelectedProfile
  };
}

function mapDispatchToProps(dispatch) {
  return {
    selectStone: (stone) => dispatch(actions.pricingPresets.selectStone(stone)),
    selectPreset: (preset) => dispatch(actions.pricingPresets.setSelected(preset)),
    closeAssignPopup: () => dispatch(actions.pricingPresets.showAssignPricing(false)),
    assignPricing: (unassign) => dispatch(actions.pricingPresets.assignPricingPresets(unassign))
  };
}

const connector = connect(mapStateToProps, mapDispatchToProps);

class assignPricingProfile extends React.Component {
  render = template;
  constructor(props) {
    super(props);
    this.state = {
      selectedPreset: this.props.selectedPreset,
      selectedStones: _.flatMap({...this.props.selectedStones}, (s) => s.id),
      profileAssignedStoneUpdates: []
    }
  }

  /**
   * return Stone's Display Name
   * @param {object} stone
   * @returns {string}
   */
  getName = (stone) => {
    const parts = stone.name.split('-');
    const name = parts[parts.length - 1].trim();
    return toTitleCase(name);
  }

  /**
   * Sets Selected Preset
   * @param {object} preset
   */
  selectPreset = (preset) => {
    this.setState({selectedPreset: preset});
    if(this._selectTimeout) window.clearTimeout(this._selectTimeout);
    this._selectTimeout = window.setTimeout(() => this.props.selectPreset(preset), 500);
  }

  /**
   * Toggles Stone Selection from Left Side List
   * @param {object} stone
   */
  selectStone = (stone) => {
    let stones = this.state.selectedStones;
    if(this.isSelected(stone)) {
      stones.splice(this.getSelectedIndex(stone), 1);
    } else {
      stones.push(stone.id);
    }
    this.setState({selectedStones: stones});
    if(this._selectStoneTimeout) window.clearTimeout(this._selectStoneTimeout);
    this._selectStoneTimeout = window.setTimeout(() => this.props.selectStone(stone), 500);
  }

  /**
   * returns index of Left Side Selection of Stone
   * @param {object} stone
   * @returns {int}
   */
  getSelectedIndex = (stone) => {
    return _.findIndex(this.state.selectedStones, (s) => s === stone.id);
  }
  
  /**
   * returns if stone is selected in Left Side Selection List
   * @param {object} stone
   * @returns {boolean}
   */
  isSelected = (stone) => {
    return this.getSelectedIndex(stone) >= 0;
  }

  /**
   * adds/remove stone to the state to indicate it has been un-checked
   * @param {object} stone
   */
  selectProfileAssignedStone = (stone) => {
    let index = this.state.profileAssignedStoneUpdates.indexOf(stone);
    if( index > -1 )
      this.state.profileAssignedStoneUpdates.splice(index, 1);
    else
      this.state.profileAssignedStoneUpdates.push(stone);
    this.setState({profileAssignedStoneUpdates: [...this.state.profileAssignedStoneUpdates]});
  }

  /**
   * checks if stone exists in the unchecked-list
   * @param {object} stone
   * @returns {boolean}
   */
  isProfileAssignedSelected = (stone) => {
    return this.state.profileAssignedStoneUpdates.indexOf(stone) === -1;
  }

  /**
   * assigns stones and removes assigned stones as needed
   */
  assignPricing = () => {
    this.props.assignPricing(this.state.profileAssignedStoneUpdates);
  }
}

const AssignPricingProfile = connector(assignPricingProfile);

export default AssignPricingProfile;
export { AssignPricingProfile };
